module.exports = __webpack_public_path__ + "img/der_01_UAV.ea34551e.png";